/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminTeam
 */
export interface InputAdminTeam {
    /**
     * 
     * @type {string}
     * @memberof InputAdminTeam
     */
    comment?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InputAdminTeam
     */
    craftNames: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof InputAdminTeam
     */
    division?: number;
    /**
     * 
     * @type {string}
     * @memberof InputAdminTeam
     */
    droneUid?: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdminTeam
     */
    flightTimeoutMinutes?: number;
    /**
     * 
     * @type {string}
     * @memberof InputAdminTeam
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof InputAdminTeam
     */
    zones?: Array<number>;
}

/**
 * Check if a given object implements the InputAdminTeam interface.
 */
export function instanceOfInputAdminTeam(value: object): boolean {
    if (!('craftNames' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function InputAdminTeamFromJSON(json: any): InputAdminTeam {
    return InputAdminTeamFromJSONTyped(json, false);
}

export function InputAdminTeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminTeam {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
        'craftNames': json['craftNames'],
        'division': json['division'] == null ? undefined : json['division'],
        'droneUid': json['droneUid'] == null ? undefined : json['droneUid'],
        'flightTimeoutMinutes': json['flightTimeoutMinutes'] == null ? undefined : json['flightTimeoutMinutes'],
        'name': json['name'],
        'zones': json['zones'] == null ? undefined : json['zones'],
    };
}

export function InputAdminTeamToJSON(value?: InputAdminTeam | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
        'craftNames': value['craftNames'],
        'division': value['division'],
        'droneUid': value['droneUid'],
        'flightTimeoutMinutes': value['flightTimeoutMinutes'],
        'name': value['name'],
        'zones': value['zones'],
    };
}

